// components/NavBar.js
import React from 'react';
import { Badge } from '../../components/ui/badge';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import { useExtractionContext } from '../../contexts/extractions/ExtractionContext';


const NavBar = ({ currentStep, navigeteToStep }) => {
  const { steps, canNavigateToStep } = useExtractionContext();

  const navMenu = steps.map(({id, label}) => ({
    id,
    label,
    active: id === currentStep,
  }));

  return (
    <div className="flex items-center gap-6 overflow-x-auto">
      {navMenu.map((step, index) => (
        (() => {
          const canNavigate = canNavigateToStep(step.id);
          const isDisabled = !step.active && !canNavigate;
          return (
        <div
          key={step.id}
          className={`flex items-center gap-3 whitespace-nowrap ${isDisabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}`}
          onClick={() => canNavigate && navigeteToStep(step.id)}
          aria-disabled={isDisabled}
        >
          <div className="flex items-center gap-2">
            <Badge
              variant={step.active ? "default" : "secondary"}
              className={`h-8 w-8 rounded-full flex items-center justify-center text-sm font-medium ${
                step.active 
                  ? 'bg-primary hover:bg-primary' 
                  : 'bg-slate-200 text-slate-600 hover:bg-slate-300'
              }`}
            >
              {step.id}
            </Badge>
            <span className={`text-sm font-medium ${step.active ? 'text-primary' : 'text-slate-500'}`}>
              {step.label}
            </span>
          </div>
          {index < steps.length - 1 && (
            <ChevronRightIcon className="h-4 w-4 text-slate-300" />
          )}
        </div>
          );
        })()
      ))}
    </div>
  );
};

export default NavBar;
